// archivo: src/app/enums/unidad-medida.enum.ts

export enum UnidadMedida {
    GRAMOS = 'g',
    KILOGRAMOS = 'kg',
    MILILITROS = 'ml',
    LITROS = 'l',
    UNIDADES = 'un',
    PAQUETE = 'pqt',
    CAJA = 'caja',
    SOBRE = 'sobre',
    BOLSA = 'bolsa',
    LATA = 'lata',
    TAZA = 'taza',
  }